import React from "react";
import { Routes, Route } from "react-router-dom";
import HazMatChecklists from "./HazMatChecklists";
import ChecklistConfigForm from "./ChecklistConfigForm";
import HazMatChecklistCategory from "./HazMatChecklistCategory/HazMatChecklistCategory";

const HazMatChecklistMgmt = () => {
  return (
    <Routes>
      <Route path="/" element={<HazMatChecklists />} />
      <Route path="/create" element={<ChecklistConfigForm />} />
      <Route path="/view/:id" element={<ChecklistConfigForm />} />
      <Route path="/edit/:id" element={<ChecklistConfigForm />} />
      <Route path="/categories" element={<HazMatChecklistCategory />} />
    </Routes>
  );
};

export default HazMatChecklistMgmt;